// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    fleet_find_vehicles: 'Buscando en la flota',
    fleet_vehicle_detail: 'Leyendo el vehículo',
    fleet_my_vehicle: 'Mirando qué vehículo llevas',
    fleet_log_fuel: 'Apuntando un repostaje',
    fleet_fuel_summary: 'Sumando el combustible',
  },
  ca: {
    fleet_find_vehicles: 'Cercant a la flota',
    fleet_vehicle_detail: 'Llegint el vehicle',
    fleet_my_vehicle: 'Mirant quin vehicle portes',
    fleet_log_fuel: 'Anotant un repostatge',
    fleet_fuel_summary: 'Sumant el combustible',
  },
  en: {
    fleet_find_vehicles: 'Looking through the fleet',
    fleet_vehicle_detail: 'Reading the vehicle',
    fleet_my_vehicle: 'Working out what you are driving',
    fleet_log_fuel: 'Writing down a refuel',
    fleet_fuel_summary: 'Adding up the fuel',
  },
  fr: {
    fleet_find_vehicles: 'Recherche dans la flotte',
    fleet_vehicle_detail: 'Lecture du véhicule',
    fleet_my_vehicle: 'Recherche du véhicule que vous conduisez',
    fleet_log_fuel: 'Enregistrement d’un plein',
    fleet_fuel_summary: 'Total du carburant',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
